export const detectAppChanges = (changes = [], rules = []) => {
  rules = !Array.isArray(rules) && typeof rules === 'object' ? [rules] : rules;

  for (let i = 0; i < rules.length; i++) {
    const { type, actionId, keys = [], custom } = rules[i];

    const basePath = type === 'action' ? `actions[id:${actionId}]` : '';
    const fullPaths = keys.map((key) => (!key ? basePath : `${basePath}.${key}`));

    const matches = changes?.filter((change) => {
      return fullPaths.some((fullPath) => change?.path === fullPath);
    });

    if (matches?.length > 0) {
      return true;
    }

    if (typeof custom === 'function') {
      const customResult = custom();
      if (customResult) {
        return true;
      }
    }
  }

  return false;
};
